import React, { useRef } from 'react';

const AvatarUploader = ({ avatarUrl, onUpload, uploadProgress }) => {
  const fileInput = useRef(null);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        onUpload(file);
      };
      reader.readAsDataURL(file);
    }
  };

  return (
      <div className="avatar-uploader">
        <div className="avatar-preview" onClick={() => fileInput.current.click()}>
          {avatarUrl ? (
              <img src={avatarUrl} alt="Profile" />
          ) : (
              <div className="avatar-placeholder">
                <span>+</span>
              </div>
          )}
          {uploadProgress > 0 && (
              <div className="upload-progress">
                <div style={{ width: `${uploadProgress}%` }} />
              </div>
          )}
        </div>
        <input
            type="file"
            ref={fileInput}
            onChange={handleFileChange}
            accept="image/*"
            hidden
        />
      </div>
  );
};

export default AvatarUploader;